import { z } from "zod";
import { Address } from "../types";

const addressSchema = z.object({
  position: z.object({
    lat: z.number(),
    lng: z.number(),
  }),
  address: z.string().min(1),
  fullAddress: z.string().min(1),
  city: z.string().min(1),
  country: z.string().min(1),
  state: z.string().min(1),
  streetName: z.string().min(1),
  streetNumber: z.string().min(1),
  postalCode: z.string().min(1),
});
export function geocodeAddress(query: string): Promise<Address> {
  return new Promise((resolve, reject) => {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: query }, (results, status) => {
      if (status === "OK" && results && results[0]) {
        const place = results[0];

        const getComponent = (type: string): string => {
          const component = place.address_components.find((c) =>
            c.types.includes(type)
          );
          return component ? component.long_name : "";
        };

        const addressData = {
          position: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          },
          address: query,
          fullAddress: place.formatted_address,
          city: getComponent("locality") || getComponent("postal_town"),
          country: getComponent("country"),
          state: getComponent("administrative_area_level_1"),
          streetName: getComponent("route"),
          streetNumber: getComponent("street_number"),
          postalCode: getComponent("postal_code"),
        };
        try {
          const validatedAddressData = addressSchema.parse(addressData);
          resolve(validatedAddressData as any);
        } catch (error) {
          reject(new Error("Google can not validate this address"));
        }
      } else {
        reject(
          new Error(
            "Geocode was not successful for the following reason: " + status
          )
        );
      }
    });
  });
}
